import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/lib/motion";
import { Mail, ArrowUpRight } from "lucide-react";

export const FinalCta = ({ onRegister }) => (
  <section data-testid="final-cta-section" className="relative overflow-hidden bg-ink py-20 md:py-36">
    <div className="absolute inset-0 spotlight" aria-hidden="true" />
    <motion.div
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      className="container-tasha relative flex flex-col items-center text-center"
    >
      <span className="overline">Turn Passion Into Purpose</span>
      <h2 className="mt-6 max-w-4xl font-serif text-5xl font-semibold leading-[1.02] tracking-tight text-cream md:text-7xl">
        You didn't come this far to stay stuck in{" "}
        <span className="font-script text-gold">research mode.</span>
      </h2>
      <p className="mt-8 max-w-xl font-sans text-lg font-light text-cream/70">
        Let's build your vision — together, the right way, in the right order.
        Join us live and make an impact that builds your legacy.
      </p>
      <button onClick={onRegister} data-testid="final-register-btn" className="btn-gold mt-10 !px-12 !py-5 !text-base">
        Save Your Free Seat
      </button>
      <p className="mt-6 font-sans text-sm uppercase tracking-[0.3em] text-cream/50">
        #AskTasha · Thursdays @ 7PM EST
      </p>
    </motion.div>
  </section>
);

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-cream/10 bg-ink-elevated py-16">
    <div className="container-tasha">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-end">
        <div>
          <div className="flex items-baseline gap-1">
            <span className="font-serif text-3xl font-semibold text-cream">#Ask</span>
            <span className="font-script text-4xl text-gold">Tasha</span>
          </div>
          <p className="mt-4 max-w-sm font-sans text-sm font-light text-cream/60">
            The Home Care Agency Launch Blueprint — your step-by-step guide to
            understanding, launching, and running a home health agency.
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <a
            href="mailto:contact@gotoasktasha.com"
            data-testid="footer-email-link"
            className="inline-flex items-center gap-2 font-sans text-base text-cream/80 transition-colors hover:text-gold"
          >
            <Mail size={18} className="text-gold" /> contact@gotoasktasha.com
          </a>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="inline-flex items-center gap-1 font-sans text-xs uppercase tracking-widest text-cream/40 transition-colors hover:text-gold"
          >
            Host Login <ArrowUpRight size={13} />
          </a>
        </div>
      </div>
      <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-cream/10 pt-8 text-center md:flex-row md:text-left">
        <p className="font-sans text-xs text-cream/40">
          © {new Date().getFullYear()} #AskTasha. All rights reserved.
        </p>
        <div className="flex items-center gap-5">
          <a href="/privacy" data-testid="footer-privacy-link" className="font-sans text-xs uppercase tracking-widest text-cream/50 transition-colors hover:text-gold">
            Privacy
          </a>
          <a href="/terms" data-testid="footer-terms-link" className="font-sans text-xs uppercase tracking-widest text-cream/50 transition-colors hover:text-gold">
            Terms
          </a>
        </div>
        <p className="font-sans text-xs text-cream/40">
          General educational information — not legal, medical, or financial advice.
        </p>
      </div>
    </div>
  </footer>
);
